import React from 'react';
import './Vision.css';

const Vision = () => {
  return (
    <div className="vision-container">
     <h1 className="company-name" style={{ fontFamily: 'El Messiri', paddingRight: '20px' }}>
        Rupasinghe Steels
      </h1>
      
      <div className="vision-column">
        <h1 className="vision-title">VISION :</h1>
        <p className="vision-text">
          Following the success of development, market expansion, and rapid growth in recent years, Rupasinghe Steels has set clear objectives for the next five years in the field of Pre-engineered steel buildings and high-rise steel structures.
        </p>
        <p className="vision-text">
          Affirming the Brand Value of RUPASINGHE STEELS - YOUR TRUSTED PARTNER
        </p>
        <p className="vision-text">
          Expanding into the International Market
        </p>
        <p className="vision-text">
          Becoming one of the Top Companies in the Industry throughout the Southeast Asia and Middle East Region
        </p>
      </div>

      <div className="mission-column">
        <h1 className="vision-title">MISSION :</h1>
        <p className="vision-text">
          With utmost dedication and existing strengths, Rupasinghe Steels aims to provide intelligent design solutions, high-quality construction projects, and efficient construction timelines that meet the expectations and optimize costs for our customers.
        </p> <br/>
        <p className="vision-text">
          Through the very projects that Rupasinghe Steels constructs, accompanying our customers will always be sustainable value and enduring presence throughout the years. In doing so, we spread positive value to all partners and suppliers, enhancing the quality of life for our employees and contributing to the development of society.
        </p>
       

        
      </div>
    </div>
  );
};

export default Vision;
